import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import { asJSON2, asJSONSafe, fetchAsBase64, fetchAsString } from "../../../functions";
import forms from "../ProtocolForms/forms";
import { toUIDate } from "../../../functions/dateHelpers";
import QRCode from "qrcode";
import { generateLink, renderPageNumeration, renderPageNumerationAndWatermark } from "../../../functions/renderProtocol";
import htmlConverter from 'html2json'
import { mapProtocolFieldNumber } from "../../../functions/viewDataMap";
import { useDispatch } from "react-redux";
import { getProtocolFormByKey } from "../../../redux/actions/protocolFormActions";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { svgToPng, svgToPngFromDpi } from "../../../functions/svgToPng";
import { injectVfsTimesNewRoman } from "../../../functions/pdfMake/timesNewRomanFonts";
import { normalizeHtml } from "../../../functions/html";
import { protocolModelFormatField } from "../../../models/protocolModel";
import { formatNumber } from "../../../functions/formatters";
import { normalizeTable } from "../../../functions/pdfMake/normalizeTable";
import ProtocolPdfModel from "../../../models/protocolPdfModel";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
injectVfsTimesNewRoman(pdfMake.vfs);

// pdfMake.fonts = {
//     // All 4 components must be defined
//     TimesNewRoman: {
//         normal: 'Times-New-Roman-Regular.ttf',
//         bold: 'Times-New-Roman-Bold.ttf',
//         italics: 'Times-New-Roman-Italic.ttf',
//         bolditalics: 'Times-New-Roman-BoldItalic.ttf'
//     }
// };

var htmlToPdfmake = require("html-to-pdfmake");


export const ProtocolPdf = ({ open, handleClose, number, logo, date, protocol, clientPdf, setClientPdf, addOptionalLogo, 
    optionalLogoUrl, logoUrl,
    protocolData, formId, protocolSigners, dateOfIssue, forceLandscape }) => {
    const formatTime = Intl.DateTimeFormat('ru-RU', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
    }).format
    const [data, setData] = useState(null);
    const [dataUrl, setDataUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    //const [signers, setSigners] = useState([]);
    // const [optionalLogoUrl, setOptionalLogoUrl] = useState(null);
    // const [logoUrl, setLogoUrl] = useState(null);
    // const [splitted, setSplitted] = useState(false);
    const dispatch = useDispatch();

    


    const fetch = async () => {
        setLoading(true);        
        const model = new ProtocolPdfModel();
        const docDefinition = await model.generatePdf(protocol, addOptionalLogo, optionalLogoUrl, logoUrl, protocolData, protocolSigners, dateOfIssue, forceLandscape);

        const pdfDocGenerator = pdfMake.createPdf(docDefinition);
        pdfDocGenerator.getBase64((result) => {
            setClientPdf(result);
        });
        // pdfDocGenerator.download(_ => {
        //
        // });
        pdfDocGenerator.getDataUrl((dataUrl) => {
            // const blob = b64toBlob(dataUrl, 'application/pdf');
            // const blobUrl = URL.createObjectURL(blob);

            // window.location = blobUrl;
            setDataUrl(dataUrl);
        });
        setLoading(false);
    }



    useEffect(() => {
        fetch();
    }, [logoUrl, optionalLogoUrl, addOptionalLogo, forceLandscape]);


    return (
        !loading
            ? <iframe src={dataUrl} style={{ width: '100%', minHeight: '900px' }}></iframe>
            : <CircularProgress size={200} />

    )
}
///